import React, { FC } from 'react';
import { TextInput, useFormContext } from 'framework/form';
import { EDITABLE_LIST_FIELD } from 'framework/list';
import { compactDisabledInputSx } from 'domain/projects/newProject/shared/compactDisabledInputSx';
import PredecessorSection from './PredecessorSection';

const getTableCells = async (isEditMode: boolean) => [
  {
    type: EDITABLE_LIST_FIELD,
    source: 'alias',
    isEditor: true,
    component: TextInput,
    componentProps: { label: '', disabled: true },
    gridCellProps: { size: 0.5, sx: compactDisabledInputSx },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'name',
    isEditor: true,
    component: TextInput,
    componentProps: { label: 'Business outcome', disabled: !isEditMode },
    gridCellProps: { size: 11 },
  },
];

const PredecessorOutcomes: FC = () => {
  const { data } = useFormContext();
  const businessOutcomes = data?.businessOutcomes ?? [];

  return (
    <PredecessorSection
      title="Business outcomes"
      listSource="businessOutcomes"
      isEmpty={businessOutcomes.length === 0}
      getTableCells={getTableCells}
    />
  );
};

export default PredecessorOutcomes;
